/*@flow*/
import type { Node } from 'react';
import React, { useContext } from 'react';
import FormContext from '../context';
import useField from './useField';
import getFieldInfo from '../util/getFieldInfo';
import factory from '../components/factory';
import type { PathT } from '../types';

export default function useListItems(
  path: PathT,
  keys: string[],
  onUp: (string, number) => any,
  onDown: (string, number) => any,
  onRemove: (string) => any
): Array<
  $NonMaybeType<
    | any
    | {|
        buttons: Array<
          any | {| click: () => void, label: string, type: string |}
        >,
        index: number,
        input: Node,
        key: string,
        value: any,
      |}
  >
> {
  const ctx = useContext(FormContext);
  const { type, value } = ctx.state;
  const { fieldOptions: listOptions } = useField(path);
  const { disableRemove, disableOrder } = listOptions;

  return keys
    .map((key, i) => {
      const itemPath = path.concat([i]);
      const {
        fieldType: itemType,
        fieldOptions: itemOptions,
        fieldValue,
      } = getFieldInfo(itemPath, type, value);
      const ItemComponent = factory(itemType, itemOptions);

      const buttons = [];
      if (!disableRemove) {
        buttons.push({
          type: 'remove',
          label: 'Remove',
          click: () => {
            onRemove(key);
          },
        });
      }
      if (!disableOrder) {
        buttons.push({
          type: 'move-up',
          label: 'Up',
          click: () => {
            onUp(key, i);
          },
        });
      }
      if (!disableOrder) {
        buttons.push({
          type: 'move-down',
          label: 'Down',
          click: () => {
            onDown(key, i);
          },
        });
      }

      return {
        input: <ItemComponent path={itemPath} key={i} />,
        key,
        buttons,
        value: fieldValue,
        index: i,
      };
    })
    .filter(Boolean);
}
